import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import "./StickyPhone.Module.css";

export const StickyPhone = () => {
    const { pathname } = useLocation();
    const isMobile = window.matchMedia("(max-width: 1024px)").matches;
    const [faded, setFaded] = useState(false);
    const [hidden, setHidden] = useState(false);
    const scrollTimer = useRef(null);

    useEffect(() => {
        setHidden(false);
        setFaded(false);
    }, [pathname]);

    useEffect(() => {
        const handleScroll = () => {
            setFaded(true);
            clearTimeout(scrollTimer.current);
            scrollTimer.current = setTimeout(() => setFaded(false), 1500);

            const footer = document.querySelector("footer");
            if (footer) {
                setHidden(footer.getBoundingClientRect().top < window.innerHeight);
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", handleScroll);
            clearTimeout(scrollTimer.current);
        };
    }, []);

    if (hidden || (pathname === "/" && isMobile)) return null;

    return (
        <a
            href="tel:+359878194897"
            className={`sticky-phone${faded ? " sticky-phone--faded" : ""}`}
            aria-label="Call for reservation"
        >
            <i className="fa-solid fa-phone"></i>
        </a>
    );
};
